const { UPLOAD_AGREEMENT, UPLOAD_AGREEMENT_SUCCESS, UPLOAD_AGREEMENT_FAILED, GET_NDA_AGREEMENT, GET_NDA_AGREEMENT_SUCCESS, GET_NDA_AGREEMENT_FAILED, SEND_AGREEMENT_MAIL, SEND_AGREEMENT_MAIL_SUCCESS, SEND_AGREEMENT_MAIL_FAILED } = require("./Constants")

const initialState = {
    Loading: false,
    successMsg: "",
    errors: "",
    data: ""
}

const NdaAgreementReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_AGREEMENT:
        case SEND_AGREEMENT_MAIL:
            return {
                ...state,
                Loading: true,
                successMsg: "",
                errors: "",
            }
        case UPLOAD_AGREEMENT_SUCCESS:
        case SEND_AGREEMENT_MAIL_SUCCESS:
            return{
                ...state,
                Loading: false,
                successMsg: action.payload,
            }
        case UPLOAD_AGREEMENT_FAILED:
        case SEND_AGREEMENT_MAIL_FAILED:
            return{
                ...state,
                Loading: false,
                errors: action.payload
            }
        case GET_NDA_AGREEMENT:
            return{
                ...state,
                Loading: true,
                successMsg:"",
                errors:""
            }
            case GET_NDA_AGREEMENT_SUCCESS:
                return{
                    ...state,
                    Loading:false,
                    data: action.payload
                }
            case GET_NDA_AGREEMENT_FAILED:
                return{
                    ...state,
                    Loading: false,
                    errors: action.payload
                }
        default:
            return state
    }
}

export default NdaAgreementReducer